import { render, staticRenderFns } from "./artworks.vue?vue&type=template&id=5c6457ba&"
import script from "./artworks.vue?vue&type=script&lang=js&"
export * from "./artworks.vue?vue&type=script&lang=js&"
import style0 from "./artworks.vue?vue&type=style&index=0&id=5c6457ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports